<template>
  <div id="app" class="page-container">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import { MdTabs } from 'vue-material/dist/components'
import VueI18n from 'vue-i18n'
import lang from '@/locales'

/**
 * Needs to come before i18n initialization --
 * Plugin installation will initialize config dependencies
 */
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: lang
})

Vue.use(MdTabs)

export default {
  name: 'App',
  i18n
}
</script>
